import React, { createContext, useContext, useMemo, useSyncExternalStore } from 'react'
import { FeatureFlags } from './feature-flags'

export interface FeatureFlagsContextValue {
  flags: Record<string, boolean>
  isEnabled: (key: string) => boolean
}

const FeatureFlagContext = createContext<FeatureFlagsContextValue | null>(null)

export function FeatureFlagProvider({ children }: { children: React.ReactNode }) {
  const subscribe = (onChange: () => void) => FeatureFlags.subscribe(() => onChange())
  const getSnapshot = () => FeatureFlags.getAllFlags()
  const getServerSnapshot = () => FeatureFlags.getAllFlags()
  const flags = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
  const value = useMemo<FeatureFlagsContextValue>(() => ({ flags, isEnabled: FeatureFlags.isEnabled.bind(FeatureFlags) }), [flags])
  return <FeatureFlagContext.Provider value={value}>{children}</FeatureFlagContext.Provider>
}

export function useFeatureFlags(): FeatureFlagsContextValue {
  const ctx = useContext(FeatureFlagContext)
  if (!ctx) throw new Error('useFeatureFlags must be used within a FeatureFlagProvider')
  return ctx
}

export default FeatureFlagContext

